// @flow
import { connect } from 'react-redux';
import React, { PureComponent } from 'react';

import { Hidden, Card } from 'seek-style-guide/react';
import HoustonAd from '../HoustonAd/HoustonAd';
import SaveSearch from '../SaveSearch/SaveSearch';

type Props = {
  authenticated: boolean,
  saveable: boolean,
  locale: Locale,
  retireDisplayAds?: string
};

const mapStateToProps = ({ saveSearch, user, location, featureFlags }) => {
  return {
    authenticated: user.authenticated,
    saveable: saveSearch.saveable,
    locale: location.locale,
    retireDisplayAds: featureFlags.retireDisplayAds
  };
};
class SideBar extends PureComponent<Props> {
  props: Props;

  render() {
    const { authenticated, saveable, locale, retireDisplayAds } = this.props;

    return (
      <Hidden mobile>
        {saveable && authenticated && <SaveSearch />}
        {retireDisplayAds ? null : (
          <Card transparent>
            <HoustonAd
              tagId={`/18718623/SEEK${locale}/jobsearch_skyscraper`}
              width={160}
              height={600}
            />
          </Card>
        )}
      </Hidden>
    );
  }
}

export default connect(mapStateToProps)(SideBar);
